export enum WindowMessages {
  ADD_PRODUCTS = 'ADD_PRODUCTS',
  BACK_TO_LOGIN = 'BACK_TO_LOGIN',
  CHECKOUT_FINISHED = 'CHECKOUT_FINISHED',
}
